import moment from 'moment';
import { useFormContext } from 'react-hook-form';

import { useTranslations } from '@lang';
import { NotesField } from '../../../components/NotesField';

import { useGroupDiningOptionsByDateAndOptionGroup } from '@features/DynamicPackagesConfigurationWizard/FormSteps/hooks/useGroupOptionsByDate';
import { some } from '@utils/some';
import { Fragment } from 'react';
import { FormBox, TableFormContainer } from '../../../components/TableForm/TableForm.styles';
import { YourStayBanner } from '../../../components/YourStayBanner';
import { usePackageConfiguration, useWizardNavigation } from '../../../contexts';
import { PackagesFormValues, TablesSchema } from '../../../types';
import { PageTitle, TablesDateContainer } from '../../FormSteps.styles';
import { useHashNavigation } from '../../hooks/useHashNavigation';
import { useStepFooter } from '../../hooks/useStepFooter';
import { TablesContainer, TablesWrapper } from '../TablesStep.styles';
import { DiningOption } from '../DiningOption/DiningOption';

export const RepeatingTablesStep = () => {
  const { journeyParams, room } = usePackageConfiguration();
  const { currentFormStep } = useWizardNavigation();

  useHashNavigation({ hash: 'tablesStep' });

  const { watch } = useFormContext<PackagesFormValues, any>();
  const { t } = useTranslations();
  const tables = watch('tables');
  const isValid = TablesSchema.safeParse(tables).success;

  const footer = useStepFooter({ isValid, titleSuffix: room.name });

  const currentStep = currentFormStep;
  const diningOptionsByDay = useGroupDiningOptionsByDateAndOptionGroup(
    moment(journeyParams.fromDate),
    moment(journeyParams.toDate),
    currentStep.diningOptions || []
  );

  // Track global option index across all days
  let globalOptionIndex = 0;

  return (
    <TablesWrapper>
      <TablesContainer>
        <PageTitle>{t('flynav.dining')}</PageTitle>
        <YourStayBanner
          fromDate={journeyParams.fromDate}
          toDate={journeyParams.toDate ?? journeyParams.fromDate}
        />
        <TableFormContainer>
          {diningOptionsByDay.map(({ date, options }) => {
            return some(options) ? (
              <Fragment key={date}>
                <TablesDateContainer>
                  <h2>{moment(date).format('D MMMM')}</h2>
                </TablesDateContainer>
                <FormBox>
                  {options.map((diningOption) => {
                    const currentIndex = globalOptionIndex++;
                    return (
                      <DiningOption
                        key={`${diningOption.id}-${currentIndex}`}
                        option={diningOption}
                        optionIndex={currentIndex}
                      />
                    );
                  })}
                </FormBox>
              </Fragment>
            ) : null;
          })}

          <FormBox>
            <NotesField name="tables.notes" label={t('tables.notes')} />
          </FormBox>
        </TableFormContainer>
        {footer}
      </TablesContainer>
    </TablesWrapper>
  );
};
